import { useQuery } from '@tanstack/react-query';
import { fetchQueue, type QueueFilters } from '../../../api/notifications';
import { queryKeys } from '../../../api/queryKeys';

export function useNotificationQueue(filters: QueueFilters) {
  return useQuery({
    queryKey: queryKeys.notifications.queue({
      status: filters.status,
      type: filters.type,
      page: filters.page,
      limit: filters.limit,
    }),
    queryFn: () => fetchQueue(filters),
    refetchInterval: 30_000,
    staleTime: 10_000,
  });
}
